// extracted by mini-css-extract-plugin
export default {"nav":"layout_nav__OqqId","page":"layout_page__1wd60","content":"layout_content__qEPMW"};